import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { ShardList } from 'components';
import { getActiveShardKey, getIsAuthenticated } from 'utilities';
import { useShards } from 'hooks/useShards';

export const SelectShard = (): JSX.Element => {
  const activeShard = useSelector(getActiveShardKey);
  const isAuthenticated = useSelector(getIsAuthenticated);

  // @ts-ignore
  const { shards, loading } = useShards(isAuthenticated, activeShard || null, false);

  if (activeShard) {
    return <Navigate to="/" />;
  }

  return <ShardList shards={shards} forLogin={true} loading={loading} />;
};
